<template>
  <fragment>
    <b-field>
      <b-input
        v-bind="$attrs"
        type="text"
        :value="value"
        expanded
        @input="$emit('input', $event)"
      />
      <p class="control">
        <image-select-button :type="type" @input="$emit('input', $event)" />
      </p>
    </b-field>
    <mc-url-parse :src="value">
      <template #temp="{ src: url }">
        <div v-if="!!url" class="box image__container">
          <img :src="url" />
        </div>
      </template>
    </mc-url-parse>
  </fragment>
</template>

<script>
import ImageSelectButton from './SelectButton';

export default {
  components: {
    ImageSelectButton
  },
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'OTHER'
    }
  }
};
</script>

<style lang="scss" scoped>
.image {
  &__container {
    display: flex;
    justify-content: center;
  }
}
</style>
